import React from 'react';
import { Link, useLocation } from 'react-router-dom';
const LafId = ({ row, field }) => {
	let globalLafId = sessionStorage.getItem('globalLafId')
	const localtion = useLocation()
	const handleSelectedColender = () => {
		if (localtion.pathname === '/portfolio/global-search') {
			localStorage.setItem('selectedColender', `/portfolio/global-search?laf_id=${globalLafId}`)
		} else {
			localStorage.setItem('selectedColender', localtion.pathname)
		}
	}
	return (
		<Link onClick={handleSelectedColender}
			to={`/portfolio/view/${row.cl_lead_id}/details`}
		>
			{row[field]}
		</Link>
	);
};

export default LafId;
